import React from "react";

import ActionDropdown from "components/Common/ActionDropdown";
import { ColumnStyle, LinkText, Steward } from "components/Common/TableStyle";

export const REFERENCE_SOURCE_COLUMNS = (handleDelete, userPermissions) => [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "40%",
    render: (text, row) => (
      <LinkText text={text} link={row.id} state={{ parent: text }} />
    ),
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "55%",
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    title: "Type",
    key: "reference_source_type",
    dataIndex: "reference_source_type",
    width: "35%",
    render: text => <div>{text.charAt(0).toUpperCase() + text.slice(1)}</div>,
  },
  {
    title: "#Domain",
    key: "domain",
    dataIndex: "domain",
    width: "30%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    width: "40%",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    width: "40%",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Action",
    key: "action",
    dataIndex: "action",
    width: "25%",
    align: "center",
    render: (_, record) => (
      <ActionDropdown
        deleteProps={{
          onClick: () => handleDelete(record),
        }}
        userPermissions={userPermissions}
      />
    ),
  },
];

export const QUICK_FILTER_DATA = [
  {
    label: "Missing Descriptions",
    value: 25,
  },
  {
    label: "Missing Crosswalk",
    value: 2,
  },
];

export const CHART_DATA = [
  {
    name: "Medication",
    Enterprise: 45,
    "Non-Enterprise": 10,
  },
  {
    name: "Provider",
    Enterprise: 54,
    "Non-Enterprise": 30,
  },
  {
    name: "Claims",
    Enterprise: 42,
    "Non-Enterprise": 28,
  },
  {
    name: "Hospital",
    Enterprise: 29,
    "Non-Enterprise": 22,
  },
];
